"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAndCreateRelativeConfig = exports.createDateListFromRelativeConfig = exports.generateDateListFromRelativeDateConfig = exports.getStartAndEndDateFromTriggerDate = exports.evaluateFormulaFromTriggerDate = exports.validateDateFormula = exports.validateAndCreateConfig = exports.isDateInConfig = exports.createDateListFromConfig = exports.generateDateList = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const configs = __importStar(require("./configs"));
const utils = __importStar(require("./utils"));
// _________________ DATE CONFIG _________________
const generateDateList = (baseDateConfigs, enforceUnique = true) => {
    let dateList = [];
    // generate date list from config
    for (const config of baseDateConfigs) {
        // if recurringDateConfig is an array, it is a list of FullDateStr
        if (lodash_1.default.isArray(config)) {
            dateList.push(...config);
        }
        else {
            const createDateList = utils.getDateListCreator(config.type);
            dateList.push(...createDateList(config));
        }
    }
    if (enforceUnique) {
        dateList = lodash_1.default.uniq(dateList);
    }
    return dateList;
};
exports.generateDateList = generateDateList;
const createDateListFromConfig = (config, enforceUnique = true) => {
    const dates = (0, exports.generateDateList)(config.recurringDateConfigs, enforceUnique);
    const exclusions = (0, exports.generateDateList)(config.exclusions, enforceUnique);
    return utils.excludeDates({
        dates,
        exclusions,
    });
};
exports.createDateListFromConfig = createDateListFromConfig;
function isDateInConfig(date, config) {
    const dateList = (0, exports.createDateListFromConfig)(config);
    return lodash_1.default.includes(dateList, date);
}
exports.isDateInConfig = isDateInConfig;
function validateAndCreateConfig(cadence, offsetDays, offsetDayUnit, period, weekdays, occurrence, startDate, endDate, frequency) {
    // top level checks
    const error = {};
    if (!period) {
        error.period = 'Period is missing.';
    }
    if (!startDate) {
        error.startDate = 'Start date is missing.';
    }
    if (!endDate) {
        error.endDate = 'End date is missing.';
    }
    if (!frequency) {
        error.frequency = 'Frequency is missing.';
    }
    if (!period || !startDate || !endDate || !frequency) {
        return { config: null, error };
    }
    switch (period) {
        case 'calendarDate':
            return configs.calendarDate.validateAndCreateConfig(startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays);
        case 'startOf':
            return configs.startOrEndOfPeriod.validateAndCreateConfig('startOf', startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays);
        case 'endOf':
            return configs.startOrEndOfPeriod.validateAndCreateConfig('endOf', startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays);
        case 'weekday':
            return configs.weekday.validateAndCreateConfig(startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays, weekdays);
        case 'weekdayByOccurrence':
            return configs.weekdayByOccurrence.validateAndCreateConfig(startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays, weekdays, occurrence);
        default:
            return (0, common_1.finleyAssertUnreachable)(period);
    }
}
exports.validateAndCreateConfig = validateAndCreateConfig;
// _________________ RELATIVE DATE CONFIG _________________
function validateDateFormula(formula) {
    return (0, formula_engine_1.getFormulaErrors)(formula, new Set(['triggerDate']));
}
exports.validateDateFormula = validateDateFormula;
const evaluateFormulaFromTriggerDate = (formula, triggerDate) => {
    const dateFormula = `TEXT(${formula}, "yyyy-mm-dd")`;
    const engine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.FullSupportedFormulaEngines.HyperFormula1, [dateFormula], undefined);
    engine.setVariables({ triggerDate });
    return engine.evaluateFullDateStr(dateFormula);
};
exports.evaluateFormulaFromTriggerDate = evaluateFormulaFromTriggerDate;
const getStartAndEndDateFromTriggerDate = (triggerDate, config) => {
    const dateRegex = common_1.consts.regExpFullDateStr.source.slice(1, -1);
    const matchRegex = new RegExp(`^\\s*"?(${dateRegex})"?\\s*$`);
    // captured group will be second element in match list
    const startMatch = config.startDateFormula.match(matchRegex);
    const endMatch = config.endDateFormula.match(matchRegex);
    const startDate = startMatch && startMatch.length === 2
        ? startMatch[1]
        : (0, exports.evaluateFormulaFromTriggerDate)(config.startDateFormula, triggerDate);
    const endDate = endMatch && endMatch.length === 2
        ? endMatch[1]
        : (0, exports.evaluateFormulaFromTriggerDate)(config.endDateFormula, triggerDate);
    return { startDate, endDate };
};
exports.getStartAndEndDateFromTriggerDate = getStartAndEndDateFromTriggerDate;
const generateDateListFromRelativeDateConfig = (relativeConfig, triggerDate, enforceUnique = true) => {
    const baseDateConfigs = [];
    for (const config of relativeConfig) {
        // get start and end dates
        const result = (0, exports.getStartAndEndDateFromTriggerDate)(triggerDate, config);
        // create a base date config
        baseDateConfigs.push(Object.assign({ startDate: result.startDate, endDate: result.endDate }, config.baseDateConfig));
    }
    return (0, exports.generateDateList)(baseDateConfigs, enforceUnique);
};
exports.generateDateListFromRelativeDateConfig = generateDateListFromRelativeDateConfig;
const createDateListFromRelativeConfig = (config, triggerDate, enforceUnique = true) => {
    const dates = (0, exports.generateDateListFromRelativeDateConfig)(config.relativeRecurringDateConfig, triggerDate, enforceUnique);
    const exclusions = (0, exports.generateDateListFromRelativeDateConfig)(config.exclusions, triggerDate, enforceUnique);
    return utils.excludeDates({
        dates,
        exclusions,
    });
};
exports.createDateListFromRelativeConfig = createDateListFromRelativeConfig;
function validateAndCreateRelativeConfig(cadence, offsetDays, offsetDayUnit, period, weekdays, occurrence, startDateFormula, endDateFormula, frequency) {
    // top level checks
    const error = {};
    if (!period) {
        error.period = 'Period is missing.';
    }
    if (!frequency) {
        error.frequency = 'Frequency is missing.';
    }
    // check if formula exists & is valid
    if (!startDateFormula) {
        error.startDate = 'Start date is missing.';
    }
    else {
        const startFormulaError = validateDateFormula(startDateFormula);
        if (startFormulaError.errorMessages.length > 0) {
            error.startDate = startFormulaError.errorMessages.join('; ');
        }
    }
    if (!endDateFormula) {
        error.endDate = 'End date is missing.';
    }
    else {
        const endFormulaErrors = validateDateFormula(endDateFormula);
        if (endFormulaErrors.errorMessages.length > 0) {
            error.endDate = endFormulaErrors.errorMessages.join('; ');
        }
    }
    if (!period ||
        !frequency ||
        !startDateFormula ||
        !endDateFormula ||
        !lodash_1.default.isEmpty(error)) {
        return { config: null, error };
    }
    switch (period) {
        case 'calendarDate':
            return configs.calendarDate.validateAndCreateRelativeConfig(startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays);
        case 'startOf':
            return configs.startOrEndOfPeriod.validateAndCreateRelativeConfig('startOf', startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays);
        case 'endOf':
            return configs.startOrEndOfPeriod.validateAndCreateRelativeConfig('endOf', startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays);
        case 'weekday':
            return configs.weekday.validateAndCreateRelativeConfig(startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays, weekdays);
        case 'weekdayByOccurrence':
            return configs.weekdayByOccurrence.validateAndCreateRelativeConfig(startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays, weekdays, occurrence);
        default:
            return (0, common_1.finleyAssertUnreachable)(period);
    }
}
exports.validateAndCreateRelativeConfig = validateAndCreateRelativeConfig;
//# sourceMappingURL=generate.js.map